const UPPER_CASE_REGEX = /[A-ZĄĘÓŚĆŻŹŃ]/;
const LOWER_CASE_REGEX = /[a-ząęóśćżźń]/;
const DIGIT_OR_SPECIAL_REGEX = /[\d!@#$%^&*()?+=._-]/;
const MIN_LENGTH = 8;

export const validateNewPassword = (password, confirmPassword) => {
  if (typeof password !== 'string' || password.length < MIN_LENGTH) {
    return 'validation.passwordErrorToShort';
  }
  if (!password.match(UPPER_CASE_REGEX)) {
    return 'validation.passwordErrorUpperCaseLetters';
  }
  if (!password.match(LOWER_CASE_REGEX)) {
    return 'validation.passwordErrorLowerCaseLetters';
  }
  if (!password.match(DIGIT_OR_SPECIAL_REGEX)) {
    return 'validation.passwordErrorDigitsOrSpecial';
  }
  if (password !== confirmPassword) {
    return 'validation.passwordErrorNotMatch';
  }
  return null;
};

export default validateNewPassword;
